<mat-card
  [style]="getColorSchemeStyle()"
  [ngClass]="!isAssigned ? 'unassigned' : 'color-scheme'"
>
  <mat-card-header>
    <mat-card-title>{{ dayText | uppercase }}</mat-card-title>
  </mat-card-header>
  <img
    id="card-image"
    mat-card-image
    [src]="gradeUnitDay.dayCoverImageUrl"
    [alt]="altText"
  />
  <mat-card-content>
    <span class="title"> {{ dayTitle }} {{ getPageTitle() }} </span>
    <div>
      <ng-container *ngIf="studentAssignment?.completedAt; else due">
        Completed
        <p class="date">
          {{ getDateCompleted() | date: 'EE, MMMM d, yyyy' }}
        </p>
      </ng-container>
      <ng-template #due>
        Due Date
        <p class="date">
          {{ getDateDue() | date: 'EE, MMMM d, yyyy' }}
        </p>
      </ng-template>
    </div>
  </mat-card-content>
  <mat-card-actions *ngIf="!gradeUnitDay?.isQuiz; else assessmentButtons">
    <button
      class="action-button"
      mat-raised-button
      appDebounceClick
      *ngIf="studentAssignment?.id && !studentAssignment?.completedAt"
      [ngStyle]="{ 'background-color': getColorSchemeButtonStyle() }"
      [class.overdue-border]="isOverdue"
      (debouncedClick)="navigate()"
    >
      {{ 'Continue Assignment' | uppercase }}
    </button>

    <button
      class="action-button"
      mat-raised-button
      appDebounceClick
      appNavigationDisable
      *ngIf="studentAssignment?.completedAt"
      [ngStyle]="{ 'background-color': getColorSchemeButtonStyle() }"
      [class.overdue-border]="isOverdue"
      (debouncedClick)="navigate()"
    >
      {{ 'Completed Assignment' | uppercase }}
    </button>
    <button
      class="action-button"
      mat-raised-button
      appDebounceClick
      appNavigationDisable
      *ngIf="!studentAssignment?.id"
      [ngStyle]="{ 'background-color': getColorSchemeButtonStyle() }"
      [class.overdue-border]="isOverdue"
      (debouncedClick)="startAssignment(gradeUnitDay.classroomAssignmentId)"
    >
      {{ 'Start Assignment' | uppercase }}
    </button>
  </mat-card-actions>
</mat-card>

<ng-template #assessmentButtons>
  <mat-card-actions>
    <button
      class="action-button"
      mat-raised-button
      appDebounceClick
      *ngIf="studentAssignment?.id && !studentAssignment?.completedAt"
      [ngStyle]="{ 'background-color': getColorSchemeButtonStyle() }"
      [class.overdue-border]="isOverdue"
      (debouncedClick)="navigate()"
    >
      {{ 'Continue Assessment' | uppercase }}
    </button>

    <button
      class="action-button"
      mat-raised-button
      appDebounceClick
      *ngIf="studentAssignment?.completedAt"
      [ngStyle]="{ 'background-color': getColorSchemeButtonStyle() }"
      [class.overdue-border]="isOverdue"
      (debouncedClick)="navigate()"
    >
      {{ 'Completed Assessment' | uppercase }}
    </button>
    <button
      class="action-button"
      mat-raised-button
      appDebounceClick
      *ngIf="!studentAssignment?.id"
      [ngStyle]="{ 'background-color': getColorSchemeButtonStyle() }"
      [class.overdue-border]="isOverdue"
      (debouncedClick)="startAssignment(gradeUnitDay.classroomAssignmentId)"
    >
      {{ 'Start Assessment' | uppercase }}
    </button>
  </mat-card-actions>
</ng-template>
